import { Dispatch, SetStateAction } from "react";
import { Modal, Button, Box, Typography } from "@mui/material";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";

interface ModalProps {
  open: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
  handleDelete: () => void;
  name: string;
}

export default function WarnModal({
  open,
  setOpen,
  handleDelete,
  name,
}: ModalProps) {
  return (
    <Modal
      className="modal addReply_modal"
      open={open}
      onClose={() => setOpen(false)}
    >
      <div className="modal-dialog" style={{ maxWidth: 450 }}>
        <div className="modal-body" style={{ textAlign: "center", padding: "40px 30px" }}>
          <Box sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            width: 72,
            height: 72,
            borderRadius: '50%',
            backgroundColor: '#fee2e2',
            margin: '0 auto 24px auto'
          }}>
            <DeleteOutlineIcon sx={{ fontSize: 36, color: '#ef4444' }} />
          </Box>
          <Typography variant="h5" sx={{ fontWeight: 600, mb: 1.5, color: '#111827', fontSize: '1.25rem' }}>
            Are you sure you want to delete this {name}?
          </Typography>
          <Typography variant="body1" sx={{ color: '#6b7280', mb: 4 }}>
            This action cannot be undone. Please confirm to proceed.
          </Typography>

          <div className="footer_btn_flex" style={{ justifyContent: "center", gap: 16 }}>
            <Button
              className="btn btn_grey"
              onClick={() => setOpen(false)}
              sx={{ flex: 1, py: 1.2 }}
            >
              Cancel
            </Button>
            <Button
              className="btn btn_primary"
              onClick={() => {
                setOpen(false);
                handleDelete();
              }}
              sx={{
                flex: 1,
                py: 1.2
              }}
            >
              Delete
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
}
